/* eslint-disable no-param-reassign */

import { createSlice } from "@reduxjs/toolkit";

import MODAL_VIEW_TYPES from "../../../constants/modalViewTypes";
import { withNamespace } from "../../constants/namespace";
import { fetchAgentMatches } from "../agentMatchSlice";
import { createListingAgentMatchConnection } from "../contactFormSlice";

const initialState = {
  isExpertMatchDrawerOpen: false,
  modalViewType: MODAL_VIEW_TYPES.loading
};

const uiSlice = createSlice({
  name: withNamespace("ui"),
  initialState,
  reducers: {
    openExpertMatchDrawer(state) {
      state.isExpertMatchDrawerOpen = true;
    },
    closeExpertMatchDrawer(state) {
      state.isExpertMatchDrawerOpen = false;
    },
    setModalViewType(state, { payload }) {
      state.modalViewType = payload;
    }
  },
  extraReducers: {
    [createListingAgentMatchConnection.rejected]: state => {
      state.modalViewType = MODAL_VIEW_TYPES.error;
    },
    [createListingAgentMatchConnection.fulfilled]: (state, action) => {
      const formErrorsPresent = Boolean(
        action.payload?.data?.create_listing_agent_match_on_hdp_connection
          ?.errors
      );

      if (formErrorsPresent) {
        state.modalViewType = MODAL_VIEW_TYPES.agentContact;
      } else {
        state.modalViewType = MODAL_VIEW_TYPES.success;
      }
    },
    [fetchAgentMatches.pending]: state => {
      state.modalViewType = MODAL_VIEW_TYPES.loading;
    },
    [fetchAgentMatches.rejected]: state => {
      state.modalViewType = MODAL_VIEW_TYPES.error;
    },
    [fetchAgentMatches.fulfilled]: state => {
      state.modalViewType = MODAL_VIEW_TYPES.agentContact;
    }
  }
});

export const {
  closeExpertMatchDrawer,
  openExpertMatchDrawer,
  setModalViewType
} = uiSlice.actions;

export default uiSlice.reducer;
